<template>
    <div class="panel-card">
        <div class="panel-header">
            <div class="panel-title">公司公告</div>
            <div class="panel-extra">
                <router-link class="text-link" to="/oa/notice">更多 &gt;</router-link>
            </div>
        </div>
        <div class="panel-body">
            <a-list :data-source="noticeList" class="notice-list-wrap">
                <template slot="renderItem" slot-scope="item">
                    <a-list-item class="notice-list-item">
                        <!-- 左侧蓝色圆点 + 公告标题 -->
                        <div class="notice-left">
                            <span class="notice-dot"></span>
                            <router-link class="notice-title" :to="`/oa/notice/detail?id=${item.id}`">
                                {{ item.title }}
                            </router-link>
                        </div>
                        <!-- 右侧日期 -->
                        <span class="notice-date">{{ $getDateString(item.publishAt) }}</span>
                    </a-list-item>
                </template>
            </a-list>
        </div>
    </div>
</template>

<script>
import { fetchList } from "@/api/oa/notice";

export default {
    name: 'CompanyNotice',
    data() {
        return {
            noticeList: []
        }
    },
    mounted() {
        fetchList({
            pageNum: 1,
            pageSize: 8,
        }).then((res) => {
            if (res && Array.isArray(res.list)) {
                this.noticeList = Object.freeze(res.list);
            }
        });
    }
}
</script>

<style scoped>
.panel-card {
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 12px;
    height: 380px;
}
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
}
.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    padding-left: 12px;
    position: relative;
}
.panel-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px;
    background-color: #2563eb;
}

.panel-body {
    padding: 5px 18px;
    height: 120px;
    overflow-y: auto;
    /* 默认隐藏滚动条，悬停显示 */
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
}
.panel-body:hover {
    scrollbar-color: #d1d5db transparent;
}
.panel-body::-webkit-scrollbar {
    width: 6px;
}
.panel-body::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
}
.panel-body:hover::-webkit-scrollbar-thumb {
    background: #d1d5db;
}
.text-link {
    color: #2563eb;
    cursor: pointer;
    text-decoration: none;
}
.text-link:hover {
    color: #1d4ed8;
}

/* 列表项 */
::v-deep .notice-list-wrap .ant-list-item {
    padding: 3px 0;
    border-bottom: none; /* 去掉item分割线，截图没有下划线 */
}
.notice-list-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.notice-left {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}
/* 蓝色圆点 */
.notice-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #2563eb;
    margin-top: 7px;
    flex-shrink: 0;
}
.notice-title {
    font-size: 14px;
    color: #333;
    text-decoration: none;
}
.notice-title:hover {
    color: #2563eb;
}
.notice-date {
    font-size: 12px;
    color: #888;
}
</style>
